// Specific locale references
export type Locale = 'en' | 'ja';
const fallbackLocale: Locale = 'ja';

export const localeRuleset = {
  fallbackLocale,
};
